module.exports = __webpack_public_path__ + "img/taller_consolas_ilum.c35d76fe.jpg";